import { beginAjaxCall, endAjaxCall } from '../AjaxStatus/AjaxStatusActions';
import HttpClient from './HttpClientInstance';
import { ReduxDispatch } from '../../../Configs/Redux/Types';

export const httpGetWithDispatch = (
  dispatch: ReduxDispatch,
  url: string,
  data: Record<string, unknown> | null,
  additionalSuccessActions?: (response: unknown) => void,
  additionalErrorActions?: (error: unknown) => void,
  showLoader = true,
  abortSignal?: AbortSignal
): Promise<unknown> => {
  return new Promise<unknown>((resolve, reject) => {
    if (showLoader) {
      dispatch(beginAjaxCall());
    }
    HttpClient.get(url, data, abortSignal)
      .then((response) => {
        if (showLoader) {
          dispatch(endAjaxCall());
        }

        if (additionalSuccessActions) {
          additionalSuccessActions(response);
        }

        resolve(response);
      })
      .catch((error) => {
        if (showLoader) {
          dispatch(endAjaxCall());
        }

        if (additionalErrorActions) {
          additionalErrorActions(error);
        }

        if (error.name !== 'AbortError') {
          reject(error);
        }
      });
  });
};

export const httpPutWithDispatch = (
  dispatch: ReduxDispatch,
  url: string,
  data: BodyInit | null = null,
  additionalSuccessActions?: (response: unknown) => void,
  additionalErrorActions?: (error: unknown) => void,
  showLoader = true
): Promise<unknown> => {
  return new Promise<unknown>((resolve, reject) => {
    if (showLoader) {
      dispatch(beginAjaxCall());
    }

    HttpClient.put(url, data)
      .then((response) => {
        if (showLoader) {
          dispatch(endAjaxCall());
        }

        if (additionalSuccessActions) {
          additionalSuccessActions(dispatch);
        }

        resolve(response);
      })
      .catch((error) => {
        if (showLoader) {
          dispatch(endAjaxCall());
        }

        if (additionalErrorActions) {
          additionalErrorActions(dispatch);
        }

        reject(error);
      });
  });
};

export const httpPostWithDispatch = (
  dispatch: ReduxDispatch,
  url: string,
  data: BodyInit | null = null,
  additionalSuccessActions?: (response: unknown) => void,
  additionalErrorActions?: (error: unknown) => void,
  showLoader = true
): Promise<unknown> => {
  return new Promise<unknown>((resolve, reject) => {
    if (showLoader) {
      dispatch(beginAjaxCall());
    }

    HttpClient.post(url, data)
      .then((response) => {
        if (showLoader) {
          dispatch(endAjaxCall());
        }

        if (additionalSuccessActions) {
          additionalSuccessActions(dispatch);
        }

        resolve(response);
      })
      .catch((error) => {
        if (showLoader) {
          dispatch(endAjaxCall());
        }

        if (additionalErrorActions) {
          additionalErrorActions(dispatch);
        }

        reject(error);
      });
  });
};
